"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = VerifyDetails;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactComponents = require("@ui-propulsion/react-components");
var _VerifyName = _interopRequireDefault(require("./VerifyName/VerifyName"));
var _VerifyRouting = _interopRequireDefault(require("./VerifyRouting/VerifyRouting"));
var _VerifyAccount = _interopRequireDefault(require("./VerifyAccount/VerifyAccount"));
var _VerifyDetails = require("./VerifyDetails.styles");
function VerifyDetails(_ref) {
  var headerText = _ref.headerText,
    fNameProps = _ref.firstName,
    lNameProps = _ref.lastName,
    routingNumber = _ref.routingNumber,
    accountNumber = _ref.accountNumber,
    confirmAccountNumber = _ref.confirmAccountNumber,
    institution = _ref.institution,
    showAccount = _ref.showAccount,
    showName = _ref.showName,
    showRouting = _ref.showRouting,
    selectedAccount = _ref.selectedAccount;
  var classes = (0, _VerifyDetails.useStyles)();
  return /*#__PURE__*/_react["default"].createElement(_reactComponents.Container, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root,
    "data-testid": "verify-details-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: classes.title,
    "data-testid": "container-header-text"
  }, headerText), showName && fNameProps && lNameProps && /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "verify-name-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_VerifyName["default"], {
    "data-testid": "verify-name",
    firstName: fNameProps,
    lastName: lNameProps
  })), showRouting && routingNumber && /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "verify-routing-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_VerifyRouting["default"], {
    "data-testid": "verify-routing",
    institution: institution,
    routingNumber: routingNumber
  })), showAccount && accountNumber && confirmAccountNumber && /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "verify-account-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_VerifyAccount["default"], {
    "data-testid": "verify-account",
    institution: institution,
    accountNumber: accountNumber,
    confirmAccountNumber: confirmAccountNumber,
    lastFour: selectedAccount.lastFour
  }))));
}
VerifyDetails.propTypes = {
  /**
   * A string to display at the top of the wrapping component.
   */
  headerText: _propTypes.string.isRequired,
  /**
   * A boolean to determine whether the Name fields should be displayed. NOTE: Both `firstName` & `lastName` must also be provided to display the Name fields.
   */
  showName: _propTypes.bool,
  /**
   * A boolean to determine whether the Account fields should be displayed. NOTE: `accountNumber` & `confirmAccountNumber` must also be provided to display the Account fields.
   */
  showAccount: _propTypes.bool,
  /**
   * A boolean to determine whether the Routing field should be displayed. NOTE: `routingNumber` must also be provided to display the Routing field.
   */
  showRouting: _propTypes.bool,
  /**
   * A bank name.
   */
  institution: _propTypes.string,
  /**
   * An object used to pass-through values to the VerifyName component.
   */
  firstName: (0, _propTypes.shape)({
    onChange: _propTypes.func,
    onBlur: _propTypes.func,
    value: _propTypes.string,
    inputprops: (0, _propTypes.shape)({}),
    errors: (0, _propTypes.shape)({})
  }),
  /**
   * An object used to pass-through values to the VerifyName component.
   */
  lastName: (0, _propTypes.shape)({
    onChange: _propTypes.func,
    onBlur: _propTypes.func,
    value: _propTypes.string,
    inputProps: (0, _propTypes.shape)({}),
    errors: (0, _propTypes.shape)({})
  }),
  /**
   * An object used to pass-through values to the VerifyAccount component.
   */
  accountNumber: (0, _propTypes.shape)({
    accountName: (0, _propTypes.shape)({}),
    lastFour: (0, _propTypes.shape)({}),
    onChange: _propTypes.func,
    onBlur: _propTypes.func,
    value: _propTypes.string,
    inputProps: (0, _propTypes.shape)({}),
    errors: (0, _propTypes.shape)({})
  }),
  /**
   * An object used to pass-through values to the VerifyAccount component.
   */
  confirmAccountNumber: (0, _propTypes.shape)({
    accountName: (0, _propTypes.shape)({}),
    lastFour: (0, _propTypes.shape)({}),
    onChange: _propTypes.func,
    onBlur: _propTypes.func,
    value: _propTypes.string,
    inputProps: (0, _propTypes.shape)({}),
    errors: (0, _propTypes.shape)({})
  }),
  /**
   * An object used to pass-through values to the VerifyRouting component.
   */
  routingNumber: (0, _propTypes.shape)({
    onChange: _propTypes.func,
    onBlur: _propTypes.func,
    value: _propTypes.string,
    inputprops: (0, _propTypes.shape)({}),
    errors: (0, _propTypes.shape)({})
  }),
  selectedAccount: (0, _propTypes.shape)({
    identifier: _propTypes.string,
    institutionName: _propTypes.string,
    accountName: _propTypes.string,
    lastFour: _propTypes.string,
    balance: _propTypes.string
  }).isRequired
};
VerifyDetails.defaultProps = {
  showName: false,
  showAccount: false,
  showRouting: false,
  institution: '',
  firstName: null,
  lastName: null,
  accountNumber: null,
  confirmAccountNumber: null,
  routingNumber: null
};
